import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { booleansDataSource } from 'infrastructure/data-sources/booleans';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IBooleanItem } from 'infrastructure/data-sources/booleans';

type Options = IBaseSelectBoxOption<IBooleanItem['id'], IBooleanItem>[];

interface IBooleanSelectBoxProps extends Omit<IBaseSelectBoxProps, 'options'> {
  trueLabel?: string;
  falseLabel?: string;
  withAll?: boolean;
}

const BooleanSelectBox: React.FC<IBooleanSelectBoxProps> = ({
  trueLabel,
  falseLabel,
  withAll,
  ...props
}) => {
  const dataSource = useMemo(
    () => booleansDataSource(trueLabel, falseLabel, withAll),
    [withAll, trueLabel, falseLabel],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default BooleanSelectBox;
